import Link from 'next/link'
import { ArrowUpRight } from 'lucide-react'

import { DefaultTypedEditorState } from '@payloadcms/richtext-lexical'

import { Media } from '@/components/Media'
import { RevealH2, RevealH3, RevealSection } from '@/components/RevealSection'
import RichText from '@/components/RichText'
import { Button } from '@/components/ui/button'
import { Organization } from '@/payload-types'

export const OrgInfo: React.FC<{
  organization: Organization
}> = ({ organization }) => {
  const websiteUrlToUse = organization.websiteUrl
    ?.replace('https://', '')
    .replace('http://', '')
    .replace('www.', '')
    .replace('/', '')
  return (
    <div className="grid h-full grid-rows-[0.3fr_auto_0.2fr] items-start border-t border-border pt-6">
      <div className="flex flex-col justify-between px-0 pb-6 md:flex-row md:items-center md:pb-16">
        <RevealH3 className="pb-6 font-family-body text-xl font-medium text-neutral-500 md:pb-0 md:text-2xl">
          Other Great Organizations
        </RevealH3>
        <RevealH2 className="font-family-body text-2xl font-semibold text-foreground md:w-1/2 md:pr-8 md:text-3xl">
          {organization.title}
        </RevealH2>
      </div>
      <div className="flex size-full justify-end border-t border-border py-6">
        <RevealSection className="flex h-full flex-col justify-between gap-6 self-end md:w-1/2">
          <RichText
            data={organization.organizationDescription as DefaultTypedEditorState}
            className="font-body text-base text-foreground md:text-lg"
          />
          <div className="mt-auto text-left">
            <Button asChild variant="link" customIcon={<ArrowUpRight className="size-3" />}>
              <Link href={organization.websiteUrl} target="_blank" rel="noreferrer noopener">
                Visit site
              </Link>
            </Button>
          </div>
        </RevealSection>
      </div>
      <div className="self-end border-t border-border pt-6">
        <div className="flex flex-col justify-between md:mb-3 md:flex-row">
          <RevealH2 className="mt-auto px-0 font-body text-lg font-medium text-card-foreground">
            Other Information
          </RevealH2>
          <RevealSection className="mt-auto flex w-full flex-wrap justify-between gap-2 md:w-1/2 md:gap-5">
            {organization.otherInformation ? (
              <RichText
                data={organization.otherInformation as DefaultTypedEditorState}
                className="m-0 mx-0 min-w-52 font-body text-base text-card-foreground md:pl-8"
              />
            ) : (
              <Link
                href={organization.websiteUrl}
                target="_blank"
                rel="noreferrer noopener"
                className="mt-auto flex justify-between font-body text-base text-card-foreground"
              >
                {websiteUrlToUse}
              </Link>
            )}
            {organization.logoImage && (
              <Media
                resource={organization.logoImage}
                context={'thumbnail'}
                className="block max-w-1/3"
              />
            )}
          </RevealSection>
        </div>
      </div>
    </div>
  )
}
